import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import {
    update_companies,
    clear_status_companie,
    get_all_companies,
    UPDATE_COMPANIES_SUCCESS,
} from "../../../redux/company";
import LoadingSpinner from "../../../components/loading-spinner";
import {URLAPI} from "../../../config";
import {Space, Switch} from "antd";

/** @module  Pages/Company/UpdateCompany */


const UpdateCompany = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {id} = useParams();
    const {_update_companies, _get_all_companies} = useSelector(
        (state) => state.company_module
    );
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [isLoading, setIsLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        if (_get_all_companies) {
            if (_get_all_companies.status === 200) {
                if (JSON.stringify(_get_all_companies.data) !== "{}") {
                    // eslint-disable-next-line
                    _get_all_companies.data.datos.map((company) => {
                        if (company.id === parseInt(id)) {
                            setForm(company);
                        }
                    });
                }
            }
        }
    }, [_get_all_companies, id]);

    useEffect(() => {
        if (_update_companies) {
            if (_update_companies.status === 200) {
                toast.success("La empresa ha sido actualizada correctamente");
                dispatch(clear_status_companie(UPDATE_COMPANIES_SUCCESS));
                dispatch(get_all_companies(token));
                setIsLoading(false);
                history.push("/empresas");
            } else if (_update_companies.status !== 0) {
                if (_update_companies.message) {
                    toast.error(_update_companies.message);
                    dispatch(clear_status_companie(UPDATE_COMPANIES_SUCCESS));
                    setIsLoading(false);
                }
            }
        }
    }, [_update_companies, dispatch, history, token]);

    const [form, setForm] = useState({
        ruc: "",
        nombre: "",
        ruc_representante_legal: "",
        representante_legal: "",
        fondo_certificado: "",
        activo: true,
        enviar_formulario: false
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            enviar_formulario: checked,
        });
    };

    const handleCheckedChangeActive = (checked) => {
        setForm({
            ...form,
            activo: checked,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        setImagePreview(url);
        setForm({
            ...form,
            fondo_certificado: e.target.files[0],
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        //validate fields
        if (form.ruc === "") {
            toast.error("Debe ingresar el ruc");
            setIsLoading(false);
            return;
        }
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre");
            setIsLoading(false);
            return;
        }
        if (form.ruc_representante_legal === "") {
            toast.error("Debe ingresar el ruc del representante legal");
            setIsLoading(false);
            return;
        }
        if (form.representante_legal === "") {
            toast.error("Debe ingresar el representante legal");
            setIsLoading(false);
            return;
        }
        if (form.fondo_certificado === "") {
            toast.error("Debe seleccionar un fondo para el certificado");
            setIsLoading(false);
            return;
        }
        let data = new FormData();
        data.append("ruc", form.ruc);
        data.append("nombre", form.nombre);
        data.append("ruc_representante_legal", form.ruc_representante_legal);
        data.append("representante_legal", form.representante_legal);
        data.append("fondo_certificado", form.fondo_certificado);
        data.append("activo", form.activo);
        data.append("enviar_formulario", form.enviar_formulario);
        dispatch(update_companies(token, id, data));
    };

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Empresas"
                            items={[
                                {label: "Empresas", link: "/empresas"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Empresa</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                id="ruc"
                                                name="ruc"
                                                label="RUC"
                                                value={form.ruc}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                id="nombre"
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                id="ruc_representante_legal"
                                                name="ruc_representante_legal"
                                                label="Ruc representante legal"
                                                value={form.ruc_representante_legal}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                id="representante_legal"
                                                name="representante_legal"
                                                label="Representante legal"
                                                value={form.representante_legal}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Input
                                                label="Fondo de certificado"
                                                name="fondo_certificado"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <div className="col-md-8 text-center">
                                            <img
                                                src={
                                                    imagePreview == null
                                                        ? `${URLAPI}${form.fondo_certificado}`
                                                        : imagePreview
                                                }
                                                alt="imagen"
                                                width={200}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mt-2">
                                            <Space size={14} direction='horizontal'>
                                                <strong>Activo</strong>
                                                <Switch
                                                    checked={form.activo}
                                                    checkedChildren="SI"
                                                    unCheckedChildren="NO"
                                                    onChange={handleCheckedChangeActive}
                                                />
                                            </Space>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <Space size={14} direction='horizontal'>
                                                <strong>Enviar formulario</strong>
                                                <Switch
                                                    checked={form.enviar_formulario}
                                                    checkedChildren="SI"
                                                    unCheckedChildren="NO"
                                                    onChange={handleCheckedChange}
                                                />
                                            </Space>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/empresas" className="btn btn-danger m-1">
                                        Cancelar
                                    </Link>

                                    <Button
                                        type="submit"
                                        className="btn btn-success"
                                        onClick={() => {
                                        }}
                                        text="Guardar"
                                        theme="success"
                                        disabled={isLoading}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateCompany;
